import { useState } from "react";
import { saveGrade } from "../Api/GradeMaster";
import { Container, Form, Button, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";

const GradeMaster = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userId = userDetails?.userId;
  const [gradeData, setGradeData] = useState({
    grade: "",
    description: "",
  });

  const handleChange = (e) => {
    setGradeData({ ...gradeData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await saveGrade(gradeData, userId); 
      toast.success(`🦄 Grade Added Successfully`);
      setGradeData({
        grade: "",
        description: "",
      });
      navigate("/gradeMaster");
    } catch (error) {
      toast.error(`🦄 Error saving grade: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
      <div className="main-content expand">
        <Container fluid className="fields-container">
          <h2 className="fields-title">Grade Master</h2>

          {loading && (
            <div className="loading-overlay">
              <Sample14 />
            </div>
          )}

          <Form onSubmit={handleSubmit} className="fields-form">
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Grade <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="grade"
                    value={gradeData.grade}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Description <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="description"
                    value={gradeData.description}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <div className="fields-btn-container">
              <Button 
                variant="primary" 
                type="submit" 
                className="fields-submit"
                disabled={loading}
              >
                {loading ? "Saving..." : "Save Grade"}
              </Button>
            </div>
          </Form>
        </Container>
      </div>
  );
};

export default GradeMaster;